import { useMemo } from 'react';
import { VendorAccountStatus } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { getVendorAccountStatusColor } from './vendor-account-status-styles';

const VENDOR_ACCOUNT_STATUS_ORDER = Object.values(VendorAccountStatus);

interface VendorAccountStatusOption<T> {
  value: T;
  label: string;
  color: string;
}

export const useVendorAccountStatusOptions = <T extends string>() => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      VENDOR_ACCOUNT_STATUS_ORDER.map(value => ({
        value,
        label: t(`enums.vendorStatus.${value}`),
        color: getVendorAccountStatusColor(value),
      })),
    [t]
  ) as VendorAccountStatusOption<T>[];
};
